import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  name: 'Sarah Jenkins',
  location: 'Small Business Owner',
  text: 'KRT Insurance made setting up benefits for my employees incredibly easy. They explained everything clearly and found a plan that fit our tight budget without sacrificing quality.',
  rating: 5
}, {
  name: 'Robert & Mary T.',
  location: 'Medicare Clients',
  text: 'Navigating Medicare was giving us a headache until we called. Our agent was so patient, walked us through our options, and made sure our preferred doctors were in-network.',
  rating: 5
}, {
  name: 'David Chen',
  location: 'Family Health Plan',
  text: "I was paying way too much for my family's health insurance. They shopped around and saved us over $300 a month for better coverage. Highly recommend their free service!",
  rating: 5
}];
export function Testimonials() {
  return <section className="py-24 bg-surface" data-id="element-322">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-323">
        <div className="text-center mb-16" data-id="element-324">
          <h2 className="text-4xl font-bold mb-4" data-id="element-325">
            Don't just take our word for it.
          </h2>
          <p className="text-lg text-slate-600" data-id="element-326">
            See what our clients have to say about working with us.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-327">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white p-8 rounded-2xl shadow-sm border border-slate-100 flex flex-col h-full" data-id="element-328">
              <div className="flex gap-1 mb-6" data-id="element-329">
                {[...Array(testimonial.rating)].map((_, i) => <Star key={i} className="w-5 h-5 fill-accent text-accent" data-id="element-330" />)}
              </div>
              <p className="text-slate-700 italic mb-8 flex-grow" data-id="element-331">
                "{testimonial.text}"
              </p>
              <div data-id="element-332">
                <p className="font-bold text-navy" data-id="element-333">{testimonial.name}</p>
                <p className="text-sm text-slate-500" data-id="element-334">{testimonial.location}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}